import * as React from 'react'
import Tab from '@mui/material/Tab'

import { HugeTabs } from '@sales-center/components'

import { useData, useHandlers } from './hooks'
import { ActivityOverdue } from '../../typings'
import { ActivityStatus } from '../../../constants'

export function ActivitySummaryTabs() {
  const { loading, activeTab } = useData()
  const { onChangeTab } = useHandlers()

  return (
    <HugeTabs value={activeTab} variant="fullWidth" onChange={onChangeTab}>
      <Tab disabled={loading} label="Overdue" value={ActivityOverdue.Overdue} />
      <Tab disabled={loading} label="To Do" value={ActivityStatus.Todo} />
      <Tab
        disabled={loading}
        label="In Progress"
        value={ActivityStatus.InProgress}
      />
      <Tab
        disabled={loading}
        label="Deferred"
        value={ActivityStatus.Deferred}
      />
      <Tab
        disabled={loading}
        label="Complete"
        value={ActivityStatus.Complete}
      />
    </HugeTabs>
  )
}
